module.exports = __webpack_public_path__ + "img/webcam-filled.76034cb2.svg";